import { isEmpty, map } from 'lodash'
import { AcatsSearchDto } from '../../../api/types'

const assembleQuery = (acatsSearchDto?: AcatsSearchDto) => {
  if (isEmpty(acatsSearchDto)) return ''
  const query = map(acatsSearchDto, (value, key) => {
    const urlEncodedValue = encodeURIComponent(`${value}`)
    return `${key}=${urlEncodedValue}`
  }).join('&')
  return `?q=${query}`
}

export default assembleQuery
